<template>
  <div class="main-content">
    <div class="container-fluid">
      <b-table striped hover :items="items" :fields="fields" :busy="loading">
        <template #cell(file)="row">
          <h5 @click="getTemporaryUrl(row.item.uuid)">
            <a href="#">{{ row.item.file }}</a>
          </h5>
        </template>

        <template #cell(actions)="row">
          <span
            v-if="row.item.stato === 'Attivo'"
            class="action-link"
            @click="changeStatus(row.item.uuid, false)"
            >Disattiva</span
          >
          <span
            v-if="row.item.stato === 'Non Attivo'"
            class="action-link"
            @click="changeStatus(row.item.uuid, true)"
            >Attiva</span
          >
          -
          <span class="action-link" @click="deleteUrl(row.item.uuid)"
            >Elimina</span
          >
        </template>

        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import TemporaryUrlSerivice from "@/services/temporary-url";

export default {
  data() {
    return {
      fields: [
        {
          key: "uuid",
          sortable: false,
        },
        {
          key: "file",
          sortable: false,
        },
        {
          key: "stato",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "",
        },
      ],
      items: [],
      loading: false,
    };
  },
  methods: {
    async getTemporaryUrls() {
      this.loading = true;

      try {
        const { docs } = await TemporaryUrlSerivice.getTemporaryUrls(this.$db);
        const urls = docs.map((doc) => doc.data());

        this.items = urls.map((url) => {
          return {
            uuid: url.uuid,
            file: url.fileName,
            stato: url.active ? "Attivo" : "Non Attivo",
          };
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async deleteUrl(uuid) {
      const conf = confirm(
        "Sei sicuro di voler eliminare questo link di condivisione?"
      );

      if (conf === true) {
        await TemporaryUrlSerivice.deleteTemporaryUrl(this.$db, uuid);

        this.getTemporaryUrls();
      }
    },

    async changeStatus(uuid, status) {
      await TemporaryUrlSerivice.changeTemporaryUrlStatus(
        this.$db,
        uuid,
        status
      );

      this.getTemporaryUrls();
    },

    async getTemporaryUrl(uuid) {
      const temporaryUrl = `${window.location.protocol}//${window.location.host}/file-preview/${uuid}`;
      await navigator.clipboard.writeText(temporaryUrl);

      this.$toast.success("Link di condivisione copiato!");
    },
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Link di condivisione");

    this.getTemporaryUrls();
  },
};
</script>

<style lang="scss" scoped>
.action-link {
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/temporary-urls/TemporaryUrlsPage.vue